angular.module('rmItemPlanner')
    .service('itemPlannerSelection', require('./itemPlannerSelection').default)
;
